import { TweenVars, Tween, TweenType, TweenCallbackType } from '../Tween';
import { Ease } from '../Ease';
import { Container, Graphics, Sprite, Texture } from 'pixi.js';
import BaseView from '../views/BaseView';
import SceneView from '../views/SceneView';
import App from '../App';
import Layout from '../utils/Layout';

export class AbstractWheel extends BaseView {
    protected scene: SceneView;
    protected radius: number;

    constructor() {
        super();
    }

    public create(scene: SceneView, radius: number) {
        this.scene = scene;
        this.radius = radius;
        let sprite = this.scene.sceneSprites.get('fortune');
        if (sprite) {
            this.show(false);
            sprite.angle = 0;
            sprite.anchor.set(0.5, 0.5)
            const canvasWidth = Layout.isLandscape() ? Layout.startW : Layout.startH;
            const canvasHeight = Layout.isLandscape() ? Layout.startH : Layout.startW;
            sprite.position.set(
                canvasWidth / 2,
                canvasHeight / 2
            );
        }
    }

    spin(stopAngle: number, rotationDuration: number, exitTime: number): Promise<boolean> {

        return new Promise<boolean>((resolve, reject) => {
            let sprite = this.scene.sceneSprites.get('fortune');
            if (sprite) {

                // Reset rotation
                sprite.rotation = 0;

                // Convert stop angle from degrees to radians
                // Convert stop angle from degrees to radians
                const stopAngleRadians = (-stopAngle * Math.PI) / 180;

                // Calculate the total duration for the specified number of rotations
                const totalDuration = rotationDuration * 10;

                // Create animation settings
                const vars: TweenVars = {
                    rotation: stopAngleRadians + (10 * 2 * Math.PI), // Add multiple rotations
                    duration: totalDuration
                };
                // Start the tween animation
                const tween = new Tween(sprite, totalDuration, vars, TweenType.To);

                // When the animation completes
                tween.eventCallback(TweenCallbackType.onComplete, () => {
                    resolve(true);

                    tween.eventCallback(TweenCallbackType.onComplete, () => {
                        // Slow down tween: Rotate slightly past the stop angle
                        const slowDownTweenVars: TweenVars = {
                            rotation: stopAngle, // Rotate slightly past the stop angle
                            duration: 0.5, // Adjust the duration as needed
                            ease: Ease.Power4Out // Easing function that decelerates quickly
                        };
                        if (sprite) {

                            const slowDownTween = new Tween(sprite, 0.5, slowDownTweenVars, TweenType.To);

                            // After the slow down tween completes, initiate the roll back
                            slowDownTween.eventCallback(TweenCallbackType.onComplete, () => {
                                // Roll back tween: Roll back to the specified angle
                            });
                        }
                    });
                });
            }
        });

    }

    show(isVisible: boolean) {
        this.scene.visible = isVisible;
    }
}
